module.exports = __webpack_public_path__ + "static/media/0110_LE_SOL_66_PELER.8714f5ed.png";